<template>
    <DownloadButton
      :downloadText="$t('functional.download')"
      :downloadingText="$t('functional.downloading')"
      :is-downloading="isDownloading"
      :displayIcon="displayIcon"
      :progress-percent="progressPercent"
      @click.native="downloadFile"
      :size="size"
      :variant="variant"
    />
  </template>

  <script>
  import DownloadButton from '@/components/library/buttons/DownloadButton.vue';
  import download from '@/utils/download';

  export default {
    name: 'DownloadFileButton',
    components: {
      DownloadButton,
    },
    props: {
      url: {
        type: String,
        required: true,
      },
      displayIcon: {
        type: Boolean,
        default: true,
      },
      fileName: {
        type: String,
        required: true,
      },
      size: {
        type: String,
        required: false,
      },
      variant: {
        type: String,
        required: false,
      },
      params: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        isDownloading: false,
        progressPercent: 0,
      };
    },
    methods: {
      downloadFile(event) {
        event.stopPropagation();
        this.isDownloading = true;

        download({
          url: this.url,
          params: this.params,
          fileName: this.fileName,
          onProgress: (data) => {
            this.progressPercent = data.percent;
          },
        })
        .catch((e) => {
          const message = this.$t('message.fail.error', { action: e.message });
          this.$bus.$emit('renderGlobalMessage', { message, icon: 'times', type: 'error' });
          this.reset(0);
        })
        .finally(this.reset);
      },
      reset(timeoutInMs = 500) {
          setTimeout(() => {
            this.isDownloading = false;
            this.progressPercent = 0;
          }, timeoutInMs);
      },
    },
  };
  </script>
